const e = {
  "video-player": "video-player",
  "video-player__service--youtube": "video-player__service--youtube",
  "video-player__service--aws-video-js": "video-player__service--aws-video-js",
  "video-player__content--absolute": "video-player__content--absolute",
  "video-player__content--absolute-active": "video-player__content--absolute-active",
  "video-player__content--relative": "video-player__content--relative",
  "video-player__content--relative-fullscreen": "video-player__content--relative-fullscreen",
  "video-player__content--relative-fill-parent-height": "video-player__content--relative-fill-parent-height",
  "video-player__content--relative-ready": "video-player__content--relative-ready",
  "video-player__content--regular": "video-player__content--regular",
  "video-player__image--fill": "video-player__image--fill",
  "video-player__overlay": "video-player__overlay",
  "video-player__overlay-icon": "video-player__overlay-icon",
  "video-player__overlay-videoloop": "video-player__overlay-videoloop",
  "video-player__overlay--hidden": "video-player__overlay--hidden",
  "video-player__close-button": "video-player__close-button",
  "video-player--fullscreen": "video-player--fullscreen",
  "video-player--fill-parent-height": "video-player--fill-parent-height",
  "video-player__image": "video-player__image",
  "video-player__image--hidden": "video-player__image--hidden",
  "video-player__image--fullscreen": "video-player__image--fullscreen",
  "video-player__image--fullscreen-playing": "video-player__image--fullscreen-playing",
  "video-player__image--error": "video-player__image--error",
  "video-player__placeholder": "video-player__placeholder",
  "video-player__placeholder--fullscreen": "video-player__placeholder--fullscreen",
  "video-description": "video-description",
  "video-description__caption": "video-description__caption",
  "video-description__copyright": "video-description__copyright"
};
export {
  e as default
};
